import React from 'react';
import '../styles/stats.css';
import Marquee from "react-fast-marquee";
import img1 from "../assets/images/slide1.png"; 
import img2 from "../assets/images/slide2.png";
import img3 from "../assets/images/slide3.png"; 
import cardIcon from "../assets/images/logomain.png";

const Stats = () => {
const flipData = [
  { 
    title: "Ayurvedic Blend", 
    desc: "Crafted with traditional herbs like Ashwagandha and Safed Musli, known for supporting overall wellbeing." 
  },
  { 
    title: "Quality Checked", 
    desc: "Prepared with careful quality practices to maintain purity and consistency in every batch." 
  },
  { 
    title: "Natural Vitality", 
    desc: "Supports daily energy, stamina, and balance through a gentle herbal approach." 
  },
  { 
    title: "Customer Loved", 
    desc: "Appreciated by many users as part of their everyday wellness routine." 
  }
];
  const logos = [img1, img2,img3, img1, img2,img3, img1, img2, img3,img1, img2 ,img3];

  return (
    <section className="unique-stats-section">
      <div className="bg-blur-orb orb-1"></div>
      <div className="bg-blur-orb orb-2"></div>

      <div className="stats-container">
        {/* TOP FLIP CARDS */}
        <div className="flip-grid-wrapper">
          {flipData.map((item, index) => (
            <div className="flip-card-outer" key={index}>
              <div className="flip-card-inner">
                <div className="flip-face flip-front">
                   <img src={cardIcon} alt="icon" className="card-mini-icon" />
                   <h3 className="card-title-front">{item.title}</h3>
                </div>
                <div className="flip-face flip-back">
                   <h3 className="card-title-back">{item.title}</h3>
                   <p className="card-desc-back">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* MAIN STATS LAYOUT */}
        <div className="stats-layout-wrapper">
         <div className="hero-stat-card">
  <span className="live-badge">Routine Based</span>
  <h2 className="glitch-text">10D+</h2>
  <p className="hero-p">
    Best experienced with regular use as part of a healthy lifestyle and wellness routine.
  </p>
</div>

         <div className="glass-grid">
  <div className="glass-stat-box box-long">
    <div className="stat-info">
      <h3>Trusted</h3>
      <p>Chosen by many wellness seekers</p>
    </div>
  </div>

  <div className="glass-stat-box">
    <h3>20+</h3>
    <p>Herbal Ingredients</p>
  </div>

  <div className="glass-stat-box">
    <h3>Natural</h3>
    <p>Honey-based herbal blend</p>
  </div>
</div>
        </div>

        {/* BOTTOM CHIPS */}
     <div className="floating-features-row">
  <div className="feat-chip">AYURVEDIC INSPIRED FORMULA</div>
  <div className="feat-chip">GENTLE HERBAL BLEND</div>
  <div className="feat-chip">TRADITIONAL MAJUN RECIPE</div>
</div>
      </div>

      {/* BRAND MARQUEE */}
      <Marquee speed={40} pauseOnHover gradient={false} className="brand-marquee-unique">
        {logos.map((logo, i) => (
          <img key={i} src={logo} alt="brand-logo" className="marquee-logo-unique" />
        ))}
      </Marquee>
    </section>
  );
};

export default Stats;